import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';

import { AuthService } from '../services/auth.service';

export const IsAuthenticatedGuard: CanActivateFn = () => {
    const router = inject(Router);
    return inject(AuthService)
        .isAuthenticated()
        .pipe(map((isAuthenticated) => (isAuthenticated ? true : router.parseUrl('/auth'))));
};
